export const FilterType = {
  default: "default",
  own: "own",
  insights: "insights",
};
